var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 128,
    viewBox: "0 0 230 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0390625,
    width: 229,
    height: 128,
    fill: "#0D0D0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.667 28H44V103H120.667",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43V78.3333L106 43H93L82 72.3333C80.6667 65 73 62.3333 67 60.3333C63 59 58.6667 57.3333 58.6667 55C58.6667 53.3333 61 51.6667 65.3333 52C68.3333 52.3333 71 52.3333 76.3333 55L81.6667 46C76.6667 43.3333 70 42 64.6667 42C58.3333 42 53 44 49.6667 47.3333C47.3333 49.6667 46.3333 52.6667 46 56C46 60.6667 47.6667 64 51.3333 66.6667C54.3333 68.6667 58 70 61.3333 71C65.6667 72.3333 69 73.6667 69 76C68.6667 79 65.3333 79.6667 63 79.6667C59 80 55.6667 79.3333 50.6667 76.3333L46 85.3333C51 88.3333 56.3333 89.6667 62.6667 89.6667C67 89.6667 73.6667 88.3333 77.3333 85L76.6667 88H89.3333L91.6667 82.3333C96.6667 83.6667 102.333 84 107.333 82.3333L109 88H131.667V74.6667H136.333C148 74.6667 155 69 155 59C155 47.6667 148.333 43 134 43H119ZM94.6667 72.3333L99.3333 57.3333H99.6667L104.333 72.3333C101 73.3333 97.6667 73.3333 94.6667 72.3333ZM131.667 64.6667V52.6667H135C139.333 52.6667 142.667 54 142.667 58.3333C142.667 63 139.333 64.6667 135 64.6667H131.667Z",
    fill: "#0D0D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/SAP.ecff989b209cfbfd80f50033ff8d5711.svg";
export { ForwardRef as ReactComponent };